import React, { useState } from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { getUserCurrency } from '../../../../utils/user';
import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import PVPChartsView from '../PVPChartsView/PVPChartsView';
import { POLICY_TYPE } from '../../../../constants/policy';

const CIPolicyStatistics = props => {
  const { intl, onChange, userDetails, PVPChartDataCI } = props;
  const [expanded, setExpanded] = useState(false);

  const currency = getUserCurrency(userDetails);
  const onChangeExpansionPanel = (event, nextExpanded) => {
    setExpanded(nextExpanded);
    if (onChange) {
      onChange(event, nextExpanded);
    }
  };

  return (
    <Accordion
      expanded={expanded}
      className="analysis-expansion analysis-expansion-overview analysis-bottom exclude-in-image"
      style={{ backgroundColor: '#3966f808' }}
      onChange={onChangeExpansionPanel}
    >
      <AccordionSummary expandIcon={<ExpandMoreIcon />} className="analysis-expansion-summary1">
        {intl.formatMessage({ id: 'Policy-Statistics' })}
      </AccordionSummary>

      <AccordionDetails className="analysis-expansion-detail">
        {/*REMOVE showing chart in analysis which both A and C can read
                 <div className="cardAnalysis analysis-expansion-element">
                  <CancerChanceChart />
                </div> */}
        <div className="cardAnalysis analysis-expansion-element">
          <PVPChartsView policyType={POLICY_TYPE.CI} data={PVPChartDataCI} currency={currency} />
        </div>
      </AccordionDetails>
    </Accordion>
  );
};

const container = connect(
  state => ({
    userDetails: state.user.userDetails,
    PVPChartDataCI: state.analysis.PVPChartData.ci
  }),
  {}
)(CIPolicyStatistics);

export default injectIntl(container);
